import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'
import store from '../store'
import { normalizeTimezone } from '@/utils/dateTimezone'
import LoginHome from '../views/LoginHome.vue'
// import HomeView from '../views/HomeView.vue'
import ElencoSensoriView from '../views/SmartDispenser.vue'
import SensorView from '../views/SensorView.vue'
import WelcomeView from '../views/WelcomeView.vue'
import SmartBinView from '../views/SmartBinView.vue'
import SmartDispenserV2 from '../views/SmartDispenserV2.vue'
import DispenserView from '../views/DispenserView.vue'
import BinView from '../views/BinView.vue'
import DoorView from '../views/DoorView.vue'
import AirView from '../views/AirView.vue'
import DashboardsView from '../views/DashboardsView.vue'
import AlertsView from '../views/AlertsView.vue'
// import UnderConstructionView from '../views/UnderCostructionView.vue'
import UsersView from '../views/UsersView.vue'
import BuildingsView from '../views/BuildingsView.vue'
import ManageSensorsView from '../views/ManageSensorsView.vue'
import WashroomFrequencyV2 from '../views/WashroomFrequencyV2.vue'
import CleaningEfficiencyView from '../views/CleaningEfficiencyView.vue'
import SensorDetailsView from '../views/SensorDetailsView.vue'
import AlertsManagementView from '../views/AlertsManagementView.vue'
import AirQualityView from '../views/AirQualityView.vue'
import LogoutView from '../views/LogoutView.vue'
import SmartButtonView from '../views/SmartButtonView.vue'
import ResetPasswordView from '@/views/ResetPasswordView.vue'
import NewDashboard from '@/views/NewDashboard.vue'
import CleaningLogView from '../views/CleaningLogView.vue'
// import { component } from 'vue/types/umd'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'LoginHome',
    component: LoginHome
  },
  {
    path: '/ResetPassword/:email/:id',
    name: 'ResetPasswordView',
    component: ResetPasswordView
  },
  {
    path: '/Logout',
    name: 'LogoutView',
    component: LogoutView
  },
  {
    path: '/airquality',
    name: 'AirQualityView',
    component: AirQualityView
  },
  {
    path: '/AlertsManagement',
    name: 'AlertsManagementView',
    component: AlertsManagementView
  },
  {
    path: '/SensorDetailsView/:id',
    name: 'SensorDetailsView',
    component: SensorDetailsView
  },
  {
    path: '/welcome',
    name: 'WelcomeView',
    component: WelcomeView
  },
  {
    path: '/manageusers',
    name: 'UsersView',
    component: UsersView
  },
  {
    path: '/managebuildings',
    name: 'BuildingsView',
    component: BuildingsView
  },
  {
    path: '/managesensors/:type',
    name: 'ManageSensorsView',
    component: ManageSensorsView
  },
  {
    path: '/alerts',
    name: 'AlertsView',
    component: AlertsView
  },
  {
    path: '/air',
    name: 'AirView',
    component: AirView
  },
  {
    path: '/door',
    name: 'DoorView',
    component: DoorView
  },
  {
    path: '/bin',
    name: 'BinView',
    component: BinView
  },
  {
    path: '/dispenser',
    name: 'DispenserView',
    component: DispenserView
  },
  {
    path: '/sensors',
    name: 'SensorView',
    component: SensorView
  },
  {
    path: '/sensori',
    name: 'ElencoSensoriView',
    component: ElencoSensoriView
  },
  {
    path: '/smartbin',
    name: 'SmartBinView',
    component: SmartBinView
  },
  {
    path: '/smartdispenser',
    name: 'SmartDispenser',
    component: SmartDispenserV2
  },
  {
    path: '/dashboards',
    name: 'DashboardsView',
    component: DashboardsView
  },
  {
    path: '/smartcleaning',
    name: 'WashroomFrequencyView',
    component: WashroomFrequencyV2
  },
  {
    path: '/cleaning-efficiency',
    name: 'CleaningEfficiencyView',
    component: CleaningEfficiencyView
  },
  {
    path: '/smartButton',
    name: 'SmartButtonView',
    component: SmartButtonView
  },
  {
    path: '/custom-dashboard',
    name: 'CustomDashboard',
    component: () => import('../views/CustomDashboard.vue')
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/new-dashboard',
    name: 'NewDashboard',
    component: NewDashboard
  },
  {
    path: '/cleaning-log',
    name: 'CleaningLogView',
    component: CleaningLogView
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach(async (to, from, next) => {
    store.commit('setPreviousRoute', from);

    const publicPaths = ['/', '/Logout'];
    const isResetPassword = to.path.startsWith('/ResetPassword');
    if (publicPaths.includes(to.path) || isResetPassword) {
        return next();
    }

    const hasCompany = store.state.company != null && store.state.company !== undefined && store.state.company !== '';
    if (hasCompany) {
        return next();
    }

    const token = localStorage.getItem('token');
    if (!token || token === '') {
        return next();
    }

    try {
        axios.defaults.headers.common['Authorization'] = token;
        const res = await axios.post(store.state.URL_REFRESH_TOKEN, {});
        if (res.data && res.data.result === 'ok') {
            store.state.company = res.data.company;
            localStorage.setItem('token', res.data.token);
            localStorage.setItem('company', res.data.company);
            store.state.menu = res.data.menu;
            store.state.avatar = res.data.avatar;
            store.state.displayName = res.data.displayName;
            axios.defaults.headers.common['Authorization'] = res.data.token;
            // Se la lambda restituisce anche un JWT, salvalo
            if (res.data.jwtToken) {
                localStorage.setItem('jwtToken', res.data.jwtToken);
            }
            // Se URL_REFRESH_TOKEN restituisce i ruoli, usali direttamente
            if (res.data.roles) {
                store.state.userRole = res.data.roles;
                localStorage.setItem('userRole', JSON.stringify(res.data.roles));
            }
            await axios.post(store.state.URL_COMPANY_DATA, { Company: store.state.company });

            // Rinnova il JWT (v1) se disponibili jwtToken e userId, così entrambi i token restano validi dopo F5
            const jwtToken = localStorage.getItem('jwtToken');
            const userId = localStorage.getItem('userId');
            if (jwtToken && userId) {
                try {
                    const jwtRes = await axios.post(
                        store.state.BASE_URL + '/v1/auth/refresh',
                        { userId },
                        { headers: { Authorization: `Bearer ${jwtToken}` } }
                    );
                    if (jwtRes.data && jwtRes.data.token) {
                        localStorage.setItem('jwtToken', jwtRes.data.token);
                    }
                } catch (jwtErr) {
                    console.warn('JWT refresh on reload failed (token may be expired):', jwtErr);
                }
            }
            if (userId) {
                store.state.userId = userId;
            }
            // Ripristina userRole da localStorage (salvato al login)
            const savedRole = localStorage.getItem('userRole');
            if (savedRole) {
                try {
                    store.state.userRole = JSON.parse(savedRole);
                } catch (e) {
                    store.state.userRole = '';
                }
            }

            // Recupera impostazioni utente (timezone, preferenze, dashboard salvate) con il JWT attuale
            const currentJwt = localStorage.getItem('jwtToken');
            if (currentJwt) {
                try {
                    const meRes = await axios.get(
                        store.state.BASE_URL + store.state.URL_GET_USER_PREFERENCES,
                        { headers: { Authorization: `Bearer ${currentJwt}` } }
                    );
                    if (meRes.data) {
                        const userData = meRes.data;
                        store.state.userId = userData.id || store.state.userId || '';
                        store.state.userEmail = userData.email || '';
                        store.state.userName = userData.username || '';
                        store.state.tenantId = userData.tenantId || '';
                        store.state.userPreferences = userData.userPreferences || { selectedCharts: [] };
                        store.state.permissions = userData.permissions || { allowedAreas: '' };
                        const tz = userData.userPreferences && userData.userPreferences.timezone
                            ? normalizeTimezone(userData.userPreferences.timezone)
                            : 'Europe/Rome';
                        store.state.timezone = tz;
                    }
                } catch (meErr) {
                    console.warn('User preferences fetch on reload failed:', meErr);
                }
            }
        }
    } catch (err) {
        console.warn('Refresh token on reload failed:', err);
    }
    next();
});

export default router
